"use strict";

define('model/workflow',['./base', 'datakit/util/url'], function (BaseModel, url) {
  var Workflow = BaseModel.extend({
    urlRoot: '/rs/api/workflow',
    start: function start() {
      var urlLink = url.template(this.urlRoot + '/start/:documentId', this);
      return this.request({
        url: urlLink,
        type: 'POST'
      });
    },
    cancel: function cancel() {
      var urlLink = url.template(this.urlRoot + '/cancel/:documentId', this);
      return this.request({
        url: urlLink,
        type: 'POST'
      });
    }
  });
  return Workflow;
});

